import { useState } from 'react';

export function ContactSection() {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    exame: '',
    data: '',
    convenio: '',
    mensagem: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5f75tpkb5a33vars1n0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          telefone: '',
          email: '',
          exame: '',
          data: '',
          convenio: '',
          mensagem: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  ) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <section id="agendamento" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-calendar-check-line"></i>
            <span>Agendamento de Exames</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Agende Seu Exame</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Entre em contato pelos nossos canais de atendimento.
          </p>
        </div>

        <div className="space-y-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info - Matriz */}
            <div id="contato" className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Informações de Contato</h3>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Atendimentos</h4>
                    <a href="tel:+553534311899" className="text-blue-600 hover:text-blue-700 cursor-pointer">
                      (35) 3431-1899 (Matriz)
                    </a>
                    <br />
                    <a href="tel:+553534314558" className="text-blue-600 hover:text-blue-700 cursor-pointer">
                      (35) 3431-4558 (Unidade Hospital)
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Atendimento via</h4>
                    <a
                      href="https://wa.me/5535988228452"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 hover:text-green-700 cursor-pointer"
                    >
                      (35) 98822-8452
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">E-mail</h4>
                    <a
                      href="mailto:novaimagemcambui@hotmail.com"
                      className="text-teal-600 hover:text-teal-700 cursor-pointer"
                    >novaimagemcambui@hotmail.com
                    </a>
                    <br />
                    <a
                      href="mailto:novaimagemtomografia@hotmail.com"
                      className="text-teal-600 hover:text-teal-700 cursor-pointer"
                    >novaimagemtomografia@hotmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Info - Unidade Hospital */}
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">Locais e Horários</h3>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-indigo-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Nova Imagem Centro de Diagnóstico por Imagem</h4>
                    <p className="text-gray-600">
                      CNPJ: <b>07.679.915/0001-14</b><br />
                      Rua Vereador Waldomiro Bueno, 130<br />
                      São Benedito - Cambuí, MG
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-indigo-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Unidade Hospital</h4>
                    <p className="text-gray-600">
                      CNPJ: <b>07.679.915/0003-86</b><br />
                      Rua Prefeito Alcino Salomon, 289<br />
                      Jardim São Benedito - Cambuí, MG
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl text-amber-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Horário de Atendimento</h4>
                    <p className="text-gray-600">
                      Segunda à Quinta: <b>7h30 às 19h</b><br />
                      Sexta: <b>7h30 às 18h</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}